<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ 'onboarding.business_profile.title' | translate }}</h4>
</div>
<div class="modal-body">
  <p>{{ 'onboarding.business_profile.body' | translate }}</p>
</div>
<div class="modal-footer">
  <button (click)="activeModal.dismiss()" class="btn btn-link">{{ 'shared.button_cancel' | translate }}</button>
  <button (click)="activeModal.close()" class="btn btn-primary">{{ 'shared.button_done' | translate }}</button>
</div>
